import axios from 'axios';

export const loginByAuthCode = async (code) => {
  return await axios.post('/api/login-by-code', {
    code,
  });
};
